import { render } from "./clone_price_list.html?vue&type=template&id=31ec6f45&external"
import script from "./clone_price_list.vue?vue&type=script&lang=js"
export * from "./clone_price_list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__